import getCoverSize from '@agilie/canvas-image-cover-position'

class Simulator {
    constructor() {
        var stageContainer = document.querySelector('.simule');

        var sources = {}
        var images = {}

        this.print = false;

        this.stageWidth = window.innerWidth;
        this.stageHeight = window.innerWidth < 769 ? (this.stageWidth * 608) / 1080 : window.innerHeight;
        if(this.stageHeight < 300){
            this.stageHeight = 300
        }

        this.stage = new Konva.Stage({
            container: 'simulatorCanvas',
            width: this.stageWidth,
            height: this.stageHeight
        });

        //iniciar as camadas
        //BG
        this.layerBg = new Konva.Layer();
        this.stage.add(this.layerBg);

        //PORTA
        this.layerPorta = new Konva.Layer();
        this.layerPorta = new Konva.Layer();
        this.stage.add(this.layerPorta);

        //Sombra
        this.layerSombra = new Konva.Layer();
        this.stage.add(this.layerSombra);

        //MAçANETA
        this.layerMacaneta = new Konva.Layer();
        this.stage.add(this.layerMacaneta);
//MAçANETA
        this.layerTexto = new Konva.Layer();
        this.stage.add(this.layerTexto);
        /**
         * NOVOS GRUPOS
         * @type {Konva.Group}
         */
        //GRUPO TEXTO
        this.groupTexto = new Konva.Group({
            draggable: true,
            visible: this.print
        });

        //GROUP MACANETA
        this.groupMacaneta = new Konva.Group({
            // draggable: true
        });



        this.ambiente = null;
        this.textura = null;
        this.sombra = null;
        this.mascara = null;
        this.macaneta = null;

        this.backgroundImagePath = '';

        //cada vez que o draw é invocado, precisa desenhar algo
        this.imageObj = new Image();
        self = this;
        this.imageObj.onload = function () {

            var imageCoverSize = getCoverSize(
                self.imageObj.naturalWidth,
                self.imageObj.naturalHeight,
                self.stageWidth,
                self.stageHeight,
                0.5,
                0.5
            );

            // console.log('imageCoverSize', imageCoverSize);

            self.ambiente = new Konva.Image({
                x: imageCoverSize.offsetLeft,
                y: imageCoverSize.offsetTop,
                // fillPatternImage: self.imageObj,
                // fillPatternOffset: { x: imageCoverSize.offsetLeft, y: imageCoverSize.offsetTop },
                // fillPatternScale: { x: scaleX, y: scaleY },
                image: self.imageObj,
                width: imageCoverSize.width,
                height: imageCoverSize.height
            });

            // add the shape to the layer
            console.log('layerBG', self.layerBg)
            self.layerBg.add(self.ambiente);

            //GRADIENTE
            self.linearGradReact = new Konva.Rect({
                x: 0,
                y: 0,
                width: self.stageWidth,
                height: self.stageHeight,
                fillLinearGradientStartPoint: {x: self.stageWidth / 2, y: 0},
                fillLinearGradientEndPoint: {x: self.stageWidth / 2, y: self.stageHeight},
                fillLinearGradientColorStops: [0, 'rgba(41,41,41,1)', 0.28, 'rgba(41,41,41,0.45)', 1, 'rgba(168,166,163,0)'],
                // stroke: 'black',
                // strokeWidth: 4,
                draggable: true,
            });

            self.layerBg.add(self.linearGradReact);
        }
        self.imageObj.src = this.backgroundImagePath ? this.backgroundImagePath : "/images/simulator/ambiente.png";
        this.images = {};

        this.sources = {
            textura: '/images/simulator/textura.png',
            porta: '/images/simulator/porta3.png',
            macaneta: '/images/simulator/CJ2357E17CR00K.jpg',
            mascara: '/images/simulator/CJ2357E17CR00K_s.png',
            logo: '/images/simulator/logo@2x.png'
        };



        this.loadImages(this.sources, function (images) {

            self.images = {
                ...self.images,
                ...images
            }

            var portaWidth = self.stageWidth / 2;
            var portaX = (self.stageWidth - portaWidth);
            var macanetaX = (portaWidth * 1178) / 1460;

            var macanetaHeight = (portaWidth * images.macaneta.naturalHeight) / images.macaneta.naturalWidth
            var macanetaY = (self.stageHeight / 2) - (macanetaHeight / 2);


            // console.log('scale-porta', 'po3 ntw ',images.porta.naturalWidth, 'porta wid',portaWidth)

            var portaScaleX = portaWidth / images.porta.naturalWidth
            var texturaScaleX = portaWidth / images.textura.naturalWidth

            self.porta = new Konva.Rect({
                x: portaX,
                y: 0,
                fillPatternImage: images.porta,
                fillPatternRepeat: 'repeat-y',
                fillPatternOffsetX: 0,
                fillPatternScaleX: portaScaleX,
                // fill: 'red',
                width: portaWidth,
                height: self.stageHeight,
                // globalCompositeOperation: 'destination-atop'
            });
            // add the shape to the layer
            self.layerPorta.add(self.porta);

            self.textura = new Konva.Rect({
                x: portaX,
                y: 0,
                // image: images.textura,
                fillPatternImage: images.textura,
                fillPatternScaleX: texturaScaleX,
                fillPatternRepeat: 'repeat-y',
                // fill: 'blue',
                width: portaWidth,
                height: self.stageHeight,
                globalCompositeOperation: 'multiply'
            });

            // add the shape to the layer
            self.layerPorta.add(self.textura);


            self.sombra = new Konva.Image({
                x: macanetaX,
                y: macanetaY,
                image: images.mascara,
                width: portaWidth - 10,
                height: macanetaHeight - 10,
                blurRadius: 20,

                shadowColor: 'black',
                shadowBlur: 20,
                shadowOffset: {x: 15, y: 14},
                shadowOpacity: 0.25,
            });
            // self.sombra.cache()
            // self.sombra.filters([Konva.Filters.Blur])
            self.layerSombra.add(self.sombra)


            self.mascara = new Konva.Image({
                x: macanetaX,
                y: macanetaY,
                image: images.mascara,
                width: portaWidth,
                height: macanetaHeight
            });


            // add the shape to the layer
            // layerMacaneta.add(mascara);

            self.groupMacaneta.add(self.mascara);

            self.macaneta = new Konva.Image({
                x: macanetaX,
                y: macanetaY,
                image: images.macaneta,
                width: portaWidth,
                height: macanetaHeight,
                globalCompositeOperation: 'source-in'
            });

            self.groupMacaneta.add(self.macaneta);
            self.layerMacaneta.add(self.groupMacaneta);

            self.layerPorta.hide();
            self.groupMacaneta.hide();
            self.layerSombra.hide();
        });


        window.addEventListener('resize', this.onResize.bind(this));
        // requestAnimationFrame(this.update.bind(this));
    }

    loadImages(sources, callback) {
        var images = {};
        var loadedImages = 0;
        var numImages = 0;
        // get num of sources
        for (var src in sources) {
            numImages++;
        }
        for (var src in sources) {
            images[src] = new Image();
            images[src].onload = function () {
                if (++loadedImages >= numImages) {
                    callback(images);
                }
            };
            images[src].src = sources[src];
        }
    }//loadimages()

    //O stage sempre vai ficar do tamanho do container
    onResize() {
        // console.log('on resize', this);
        var container = document.querySelector('.simule');
        // console.log()

        // now we need to fit stage into parent container
        this.stageWidth = container.offsetWidth;
        this.stageHeight = window.innerWidth < 769 ? (this.stageWidth * 332) / 703 : window.innerHeight;

        if(this.stageHeight < 300){
            this.stageHeight = 300
        }

        this.stage.width(this.stageWidth);
        this.stage.height(this.stageHeight);

        this.update();


        // this.stage.scale({ x: scale, y: scale });
    }


    //DESENHA
    update() {
        // console.log('update canvas', this.stageWidth, this.ambiente);

        if (this.ambiente) {
            console.log('this.ambiente', this.ambiente)
            var size = this.ambiente.size();
            if (this.ambiente.image() !== this.imageObj) {
                console.log('this.ambiente', this.imageObj, this.ambiente.image())

                this.ambiente.image(this.imageObj)
            }
            var imageCoverSize = getCoverSize(
                this.imageObj.naturalWidth,
                this.imageObj.naturalHeight,
                this.stageWidth,
                this.stageHeight,
                0.5,
                0.5
            );

            this.ambiente.width(imageCoverSize.width);
            this.ambiente.height(imageCoverSize.height);

            // this.ambiente.fillPatternOffset( { x: x, y: y });
            // this.ambiente.fillPatternScale({ x: scale, y: scale});
            // this.ambiente.scale( { x: scale, y: scale });
            this.ambiente.position({x: imageCoverSize.offsetLeft, y: imageCoverSize.offsetTop});

            this.linearGradReact.width(this.stageWidth);
            this.linearGradReact.height(this.stageHeight);
        }

        if (this.texturaReady) {

        }
        var portaWidth = this.stageWidth / 2;
        var portaX = (this.stageWidth - portaWidth);
        var macanetaX = (portaWidth * 1178) / 1460;


        var macanetaHeight = (portaWidth * this.images.macaneta.naturalHeight) / this.images.macaneta.naturalWidth
        var macanetaY = (this.stageHeight / 2) - (macanetaHeight / 2);
        var portaScaleX = portaWidth / this.images.porta.naturalWidth
        var texturaScaleX = portaWidth / this.images.textura.naturalWidth

        if (this.porta) {

            // console.log('st', this.stageWidth, 'posX', portaX);

            this.porta.position({x: portaX, y: 0});
            this.porta.width(portaWidth);
            this.porta.height(this.stageHeight);
            this.porta.fillPatternScaleX(portaScaleX);

            // this.porta.fillPatternOffset({ x:x, y:y })


            if (this.textura.fillPatternImage() !== this.images.textura) {
                this.textura.fillPatternImage(this.images.textura);
            }

            this.textura.position({x: portaX, y: 0});
            this.textura.width(portaWidth);
            this.textura.height(this.stageHeight);
            this.textura.fillPatternScaleX(texturaScaleX);

            //

            // this.textura.draw();
        } //porta?


        if(this.legendaText){
            if(this.print){
                this.groupTexto.show();
            } else {
                this.groupTexto.hide();
            }

            this.legendaText.position({ x: 20, y: self.stageHeight - 100 });
            var legendaPos = self.legendaText.getClientRect();
            // console.log('legendaPOs', legendaPos)
            // this.goldLine.position({ x: legendaPos.x+10, y:legendaPos.y + 20 });
            this.goldLine.destroy();
            this.goldLine = new Konva.Line({
                points: [legendaPos.x+10, legendaPos.y + 20, legendaPos.x +10, legendaPos.y + legendaPos.height - 20 ],
                stroke: 'rgb(138,96,14)',
                strokeWidth: 2,
            });
            this.groupTexto.add(self.goldLine);
            // alert(this.print);
        }

        if(this.macaneta){
            //

            var scale = portaWidth / this.macaneta.width();
            console.log('the scale', scale, this.macaneta.width() );

            if(this.macaneta.image !== this.images.macaneta) {
                this.macaneta.image(this.images.macaneta);
                this.mascara.image(this.images.mascara);
                this.sombra.image(this.images.mascara);
            }

            this.macaneta.width(portaWidth);
            this.macaneta.height(macanetaHeight);

            this.mascara.width(portaWidth);
            this.mascara.height(macanetaHeight);

            this.sombra.width(portaWidth);
            this.sombra.height(macanetaHeight);
            //Destaivando pois esta criando um blur na fechadura
            // this.sombra.cache();
            // this.sombra.filters([Konva.Filters.Blur]);


            this.mascara.position({ x: macanetaX, y: macanetaY });
            this.sombra.position({ x: macanetaX, y: macanetaY });
            this.macaneta.position({ x: macanetaX, y: macanetaY });
        }


        // requestAnimationFrame(this.update.bind(this));
    } //update()

    //mudar o ambiente on the fly
    setAmbiente(source) {
        console.log('simulator.js: setAmbiente', source)
        this.sources.ambiente = source
        var self = this
        this.loadImages(this.sources, function (images) {
            console.log('setAmbiente', images);
            self.images = {
                ...self.images,
                ...images
            }
            self.imageObj = self.images.ambiente
            self.update()
        })
        // console.log('set ambiente', source)
        // this.imageObj.src = source
        var self = this
        // this.imageObj.onload = function () {
        //     console.log('onload', self.imageObj)
        //     self.update()
        // }
    }

    setTextura(source) {
        console.log('simulator.js set texture', source)
        this.sources.textura = source
        var self = this;
        this.layerPorta.show();
        this.loadImages(this.sources, function (images) {
            self.images = {
                ...self.images,
                ...images
            }
            self.update();
        });
    }

    setTexto(modelo, acamento, codigo) {
        var myFont = new FontFace('Filson Pro Book', 'url(assets/fonts/FilsonProBook.otf)');
        var self = this;
        myFont.load().then(function (font) {
            document.fonts.add(font);

            if(self.legendaText){
                self.legendaText.destroy();
            }

            self.legendaText = new Konva.Text({
                x: 20,
                y: self.stageHeight - 100,
                text: modelo + '\n' + acamento + '\n' + codigo,
                fontSize: 18,
                fontFamily: 'Filson Pro Book',
                lineHeight: 1.3,
                fill: '#FFF',
                width: 400,
                padding: 20,
                align: 'left',
            });


            var legendaPos = self.legendaText.getClientRect()
            self.goldLine = new Konva.Line({
                points: [legendaPos.x+10, legendaPos.y + 20, legendaPos.x +10, legendaPos.y + legendaPos.height - 20 ],
                stroke: 'rgb(138,96,14)',
                strokeWidth: 2,
            });

            self.logo = new Konva.Image({
                x: 20,
                y: 20,
                image: self.images.logo,
                width: 100,
                height: 44
            });
            self.groupTexto.add(self.logo);
            self.groupTexto.add(self.goldLine);
            self.groupTexto.add(self.legendaText);
            self.layerTexto.add(self.groupTexto);
        })
    }


    setMacaneta(mascara, macaneta){
        this.sources.mascara = mascara
        this.sources.macaneta = macaneta
        var self = this;
        this.layerSombra.show();
        this.groupMacaneta.show();
        this.loadImages(this.sources, function (images) {
            console.log('set images', images);
            self.images = {
                ...self.images,
                ...images
            }
            self.update();
        });
    }

    toDataURL(){
        return this.stage.toDataURL()
    }

    goPrint(){
        this.print = true
        this.update()
        var data64 =this.stage.toDataURL()
        this.print = false
        this.update()
        return data64
    }

} //Simulator()
export default Simulator